import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore }     from '@store/authStore'
import { canAccessRoute }   from '@utils/permissions'
import { ROUTES }           from '@constants/routes'

/**
 * PermissionRoute — fine-grained permission guard inside /admin/*.
 *
 * Usage:
 *   <PermissionRoute permission="users:read">
 *     <UserListPage />
 *   </PermissionRoute>
 *
 *   permission can be a string or string[] (any-match).
 *   If undefined, all authenticated users pass.
 */
export function PermissionRoute({ permission, children }) {
  const user = useAuthStore((s) => s.user)

  if (!user) return <Navigate to={ROUTES.AUTH.LOGIN} replace />

  if (!canAccessRoute(user.permissions ?? [], permission)) {
    return <Navigate to={ROUTES.FORBIDDEN} replace />
  }

  return children ?? <Outlet />
}
